<div class="content">
  <rt-requisitions-notes-container></rt-requisitions-notes-container>
</div>
